import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { adminAPI } from '@/lib/api';
import { toast } from 'sonner';
import { ArrowLeft, Download, Send } from 'lucide-react';

export default function AdminListDetail() {
  const { listId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await adminAPI.getExportList(listId);
        setData(res.data);
      } catch (err) {
        toast.error('Erro ao carregar lista');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [listId]);

  const handleMarkSent = async () => {
    try {
      await adminAPI.markSent(listId);
      toast.success('Lista marcada como enviada!');
      const res = await adminAPI.getExportList(listId);
      setData(res.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro');
    }
  };

  if (loading) return <div className="flex justify-center py-20"><div className="rn-spinner" style={{width:32,height:32}} /></div>;
  if (!data) return <div className="text-center py-20 text-white/40">Lista nao encontrada</div>;

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate('/admin/lists')} className="p-2 rounded-xl hover:bg-white/5">
          <ArrowLeft size={20} />
        </button>
        <div className="flex-1">
          <h1 className="font-display text-2xl font-semibold">{data.name}</h1>
          <p className="text-sm text-white/50">Associacao: {data.associationName}</p>
        </div>
        <span className={data.status === 'sent' ? 'badge-success' : 'badge-warning'}>
          {data.status === 'sent' ? 'Enviada' : 'Gerada'}
        </span>
      </div>

      <div className="flex gap-3">
        <a href={adminAPI.downloadXlsx(listId)} className="btn-secondary flex items-center gap-2">
          <Download size={16} /> Baixar XLSX
        </a>
        <a href={adminAPI.downloadZip(listId)} className="btn-secondary flex items-center gap-2" data-testid="admin-generate-zip-button">
          <Download size={16} /> Baixar ZIP
        </a>
        {data.status === 'generated' && (
          <button onClick={handleMarkSent} className="btn-primary flex items-center gap-2" data-testid="admin-mark-sent-button">
            <Send size={16} /> Marcar como Enviada
          </button>
        )}
      </div>

      <div className="rn-card">
        <h3 className="font-display text-lg font-semibold mb-4">Processos na Lista ({data.items?.length || 0})</h3>
        <div className="overflow-x-auto">
          <table className="w-full min-w-[600px]">
            <thead>
              <tr className="border-b border-white/10">
                <th className="text-left text-xs text-white/50 py-3 px-4">Cliente</th>
                <th className="text-left text-xs text-white/50 py-3 px-4">CPF/CNPJ</th>
                <th className="text-left text-xs text-white/50 py-3 px-4">Progresso</th>
              </tr>
            </thead>
            <tbody>
              {data.items?.map((item) => (
                <tr key={item.id} className="border-b border-white/5">
                  <td className="py-3 px-4 text-sm">{item.user?.name || 'N/A'}</td>
                  <td className="py-3 px-4 text-sm font-mono text-white/80">{item.case?.docFormatted}</td>
                  <td className="py-3 px-4 text-sm">{item.case?.progress}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
